import { reactive } from "vue";
import { Module } from "vuex";
import { AxiosResponse } from "axios";
import reportsApi from "@/services/api/reportsApi";

const state = reactive({});

export type reportsState = typeof state;

const reportsStore: Module<reportsState, never> = {
  namespaced: true,
  state,
  actions: {
    getLotsReports(_, params: { estateId: string }): Promise<AxiosResponse> {
      return reportsApi.getLotsReports(params.estateId);
    },
    getStagesReports(_, params: { estateId: string }): Promise<AxiosResponse> {
      return reportsApi.getStagesReports(params.estateId);
    },
    getLotsAuditLogs(_, params: { estateId: string }): Promise<AxiosResponse> {
      return reportsApi.getLotsAuditLogs(params.estateId);
    },
    exportReport(_, payload: Record<string, unknown>): Promise<AxiosResponse> {
      return reportsApi.exportReport(payload);
    },
  },
};

export default reportsStore;
